import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import VerificationLayout from "../../layout/VerificationLayout.component";
import ecCongrats from "../../../assets/images/delivery.png";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import AppButton from "../../base/AppButton.component";
import { useNavigate } from "react-router-dom";
import { details } from "./Login.style";
console.log("Selected Value");
const SelectMFAComponent = ({ onMfaOptionChange, handleKeyPress }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const options = [
    {
      label: "Email",
      value: "email",
    },
    {
      label: "Text",
      value: "text",
    },
  ];
  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    onMfaOptionChange(selectedValue);
    console.log("Selected Value ", selectedValue);
  };
  const handleChange = (event) => {
    
    if (event.key === "Enter") {
      console.log("Enter ", event);
      handleKeyPress({ key: "Enter" });
    }
  };
  return (
    <Box>
      <Typography variant="span" component="div" sx={details(theme)}>
        Select the mfa option
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <FormControl>
          <RadioGroup
            onKeyDown={handleChange}
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            sx={{ m: 1 }}
            onChange={handleOptionChange}
          >
            {options.map((option, index) => (
              <FormControlLabel
                key={index}
                value={option.value}
                control={<Radio size="medium" />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </FormControl>

        {/* <AppButton
        buttonText="Submit"
        sx={{ m: 1 }}
        clickHandler={() => {
          navigate(`/mfaSubmit`, { replace: true });         
        }}
        disabled={!selectedOption}
      /> */}
      </Box>
    </Box>
  );
};

export default SelectMFAComponent;
